<div class="custom-sidenav-panel">
  <h3 class="sidenav-header-title">
    <fa-icon [icon]="['far', 'cogs']" size="lg"></fa-icon> &nbsp;
    {{ 'HOME.SETTINGS' | translate }}
  </h3>

  <div class="sidenav-layout-container">
    <h4 class="sidenav-section-title">
      {{ 'PRODUCT.EPP.PARAMETERSET.SETS.pigeon' | translate }} -
      {{ 'PRODUCT.EPP.SETTINGS.TABLE.CFG' | translate }}
    </h4>
    <p class="mat-body-small text-muted">
      {{ 'PRODUCT.EPP.SETTINGS.TABLE.DRAGNDROP' | translate }}
    </p>

    <mat-divider></mat-divider>

    <!-- Scrollbarer Hauptbereich -->
    <div class="sidenav-scroll-content">
      <mat-accordion class="sidenav-accordion">
        @for (parameterset of parameterSets(); track parameterset) {
          <mat-expansion-panel
            [expanded]="parameterset === selectedParameterSet()">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <fa-icon [icon]="['far', 'tasks']"></fa-icon> &nbsp;
                {{
                  'PRODUCT.EPP.PARAMETERSET.SETS.' + parameterset | translate
                }}
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="parameter-set-group">
              <h5 class="parameter-group-header">
                <span>
                  {{
                    'PRODUCT.EPP.PARAMETERSET.SETS.' + parameterset | translate
                  }}
                </span>

                <mat-checkbox
                  class="select-all-checkbox"
                  [checked]="isAllSelected()"
                  [indeterminate]="isSomeSelected()"
                  (change)="toggleSelectAll($event.checked)">
                  {{ 'PRODUCT.COMMON.SELECTALL' | translate }}
                </mat-checkbox>
              </h5>

              @let settingsParametersValue = settingsParameters();

              <mat-selection-list
                class="sidenav-selection-list"
                cdkDropList
                [cdkDropListData]="settingsParametersValue"
                (cdkDropListDropped)="onDrop($event)"
                (selectionChange)="onParameterSelectionChange($event)">
                @for (entry of settingsParametersValue; track $index) {
                  <mat-list-option
                    cdkDrag
                    checkboxPosition="after"
                    class="sidenav-list-item"
                    [value]="entry.parameter"
                    [selected]="entry.selected">
                    <span matListItemIcon class="list-item-icon-wrapper">
                      <!-- Drag-Zone färbt sich im Dark Mode automatisch über var(--text-color) -->
                      <div class="static-icon-zone">
                        <ng-container
                          appWmIcon
                          [inputParameter]="entry.parameter"></ng-container>
                      </div>
                    </span>

                    <span matListItemLine class="list-item-text">
                      {{ 'METPARA_EPP.' + entry.parameter | translate }}
                    </span>

                    <mat-divider></mat-divider>
                  </mat-list-option>
                }
              </mat-selection-list>
            </div>
          </mat-expansion-panel>
        }
      </mat-accordion>
    </div>

    <mat-divider></mat-divider>

    <!-- Fixierter Footer mit einheitlicher CSS-Struktur -->
    <div class="sidenav-footer-actions">
      <button
        mat-flat-button
        class="btn-restore"
        (click)="onRestoreStandardSettings()"
        [matTooltip]="'PRODUCT.EPP.SETTINGS.RESTORE' | translate">
        <fa-icon [icon]="['far', 'sync']"></fa-icon>
      </button>

      <button
        mat-flat-button
        color="warn"
        class="btn-cancel"
        (click)="onCancelSettings()">
        <fa-icon [icon]="['far', 'times']"></fa-icon>
        {{ 'PRODUCT.EPP.SETTINGS.CANCEL' | translate }}
      </button>

      <button
        mat-flat-button
        color="primary"
        class="btn-save"
        (click)="onSaveSettings()">
        <fa-icon [icon]="['far', 'check']"></fa-icon>
        {{ 'PRODUCT.EPP.SETTINGS.SAVE' | translate }}
      </button>
    </div>
  </div>
</div>
